import React, { useState } from 'react';
import '../styles/Contact.css';

interface FormData {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

const Contact: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>Get in touch with our expert team for your web development needs</p>
      </section>

      <section className="contact-content">
        <div className="contact-info">
          <div className="info-item">
            <i className="fas fa-map-marker-alt"></i>
            <div>
              <h3>Our Location</h3>
              <p>SCL Networks Pvt Ltd</p>
              <p>Mohali, Punjab</p>
              <p>India</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-globe"></i>
            <div>
              <h3>Work Hours (IST)</h3>
              <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p>Available for urgent support 24/7</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-handshake"></i>
            <div>
              <h3>Hire Us on Upwork</h3>
              <p>
                <a href="https://www.upwork.com/agencies/425211498110021632/" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="upwork-link">
                  View Our Agency Profile <i className="fas fa-external-link-alt"></i>
                </a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-star"></i>
            <div>
              <h3>Our Expertise</h3>
              <p>PHP Development</p>
              <p>Laravel Framework</p>
              <p>Full Stack Development</p>
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Your Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject *</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Your Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={6}
              ></textarea>
            </div>

            <button type="submit" className="submit-button">Send Message</button>
          </form>
        </div>
      </section>

      <section className="agency-stats">
        <div className="stat-container">
          <div className="stat-item">
            <i className="fas fa-check-circle"></i>
            <h3>100%</h3>
            <p>Job Success</p>
          </div>
          <div className="stat-item">
            <i className="fas fa-star"></i>
            <h3>5.0/5.0</h3>
            <p>Client Rating</p>
          </div>
          <div className="stat-item">
            <i className="fas fa-clock"></i>
            <h3>22+</h3>
            <p>Years Experience</p>
          </div>
          <div className="stat-item">
            <i className="fas fa-users"></i>
            <h3>50+</h3>
            <p>Team Members</p>
          </div>
        </div>
      </section>

      <section className="map-section">
        <h2>Find Us on Map</h2>
        <div className="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27446.557256955857!2d76.69138583336283!3d30.704798074278825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fee906da6f81f%3A0x4dd61a6ada92009d!2sMohali%2C%20Punjab!5e0!3m2!1sen!2sin!4v1644286590170!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            title="SCL Networks Location"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact; 